'use strict';

var $ = require('jquery');
var debounce = require('../utilities/debounce');

module.exports = function (options) {
    var context = options.context;

    function makeMobile($this) {
        var columns = [];

        // if not already mobile then make mobile
        if (!$this.hasClass('responsive-table__mobile')) {

            $this.addClass('responsive-table__mobile');

            $this.find('tr').each(function (x) {
                if (x === 0) {
                    $(this).find('td').each(function (i) {
                        if (i > 0) {
                            columns.push($(this).text());
                        }
                    });
                } else {
                    $(this).find('td').each(function (i) {
                        if (i > 0) {
                            $(this).before('<td class="inserted">' + columns[i - 1] + '</td>');
                        }
                    });
                }
            });
        }
    }

    function destroyMobile($this) {
        // if mobile then destroy mobile
        if ($this.hasClass('responsive-table__mobile')) {
            $this.removeClass('responsive-table__mobile');
            $this.find('.inserted').remove();
        }
    }

    function checkWidth() {
        context.find('.responsive-table').each(function () {
            var tableWidth = $(this).width();

            if (tableWidth < 500) {
                makeMobile($(this));
            } else {
                destroyMobile($(this));
            }
        });
    }

    function init() {

        checkWidth();

        $(window).on('resize', debounce(function () {
            checkWidth();
        }, 500));
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/responsive-table.js
// module id = 487
// module chunks = 0